<div
  *ngIf="notification$ | async as notification"
  fxLayout="row"
  fxLayoutAlign="start center"
  fxLayoutGap="16px"
  class="notification"
>
  <pr-automation-configuration-status dense [automation]="notification" />

  <div fxFlex>
    <h3>{{ notification.name }}</h3>
    <p>
      {{ notification.type }} -
      <span class="mat-caption">{{
        notification.timing | prTimingDisplay
      }}</span>
    </p>
  </div>
  <ng-content />
</div>
